import { useState, useCallback } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import { accessCheck } from '../../../services/accessCheck';

interface UseAgentsDashboardAccessReturn {
  isCheckingAccess: boolean;
  isAuthorized: boolean | null;
  checkAccess: (agentArn: string) => Promise<void>;
}

export const useAgentsDashboardAccess = (): UseAgentsDashboardAccessReturn => {
  const [isCheckingAccess, setIsCheckingAccess] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

  const checkAccess = useCallback(
    async (agentArn: string): Promise<void> => {
      if (isAuthorized !== null) {
        return;
      }

      setIsCheckingAccess(true);
      try {
        const result = await accessCheck(agentArn);
        setIsAuthorized(result.authorized);

        if (result.authorized) {
          datadogLogs.logger.info('Agent Dashboard access granted', { agentArn });
        }
      } catch (error) {
        console.error('Error checking authorization:', error);
        setIsAuthorized(false);
      } finally {
        setIsCheckingAccess(false);
      }
    },
    [isAuthorized]
  );

  return {
    isCheckingAccess,
    isAuthorized,
    checkAccess
  };
};
